// src/utils/checkPermission.js

import { useGlobal } from "../../GlobalContext";


/**
 * Hook to check role-based permissions
 * @returns {function} checkPermission(menuName: string, permission: string): boolean
 */
export const usePermission = () => {
  const { rolePermissionList, userType } = useGlobal();

  const checkPermission = (menuName, permission) => {
    if (!rolePermissionList || rolePermissionList.length === 0) return false;

    return (
      rolePermissionList.findIndex(
        (element) =>
          element["name"] === menuName &&
          element["menu_permission"] === true &&
          element[permission] === true
      ) > -1
    );
  };

  return { checkPermission, userType };
};
